import React from "react";
import { v4 as uuidv4 } from "uuid";
import { approxSnow, titaniumWhite } from "../../../../common/helpers/colors";
import {
  getTumourFreq,
  formatNumber,
} from "../../../../common/helpers/helpers";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";

const firstRowHeaderOrder = [
  { key: "t_ref_count", label: "Tumor reference allele count" },
  { key: "t_alt_count", label: "Tumor alternative allele count" },
  { key: "tumor_frequency", label: "Tumor frequency" },
  { key: "t_depth", label: "Tumor depth" },
  { key: "n_ref_count", label: "Normal reference allele count" },
  { key: "n_alt_count", label: "Normal alternative allele count" },
  { key: "normal_frequency", label: "Normal frequency" },
  { key: "n_depth", label: "Normal depth" },
  { key: "pub_med_references", label: "Pubmed" },
];

const secondRowHeaderOrder = [
  { key: "biotype", label: "Biotype" },
  { key: "hotspot", label: "Hotspot" },
  { key: "pick", label: "Pick" },
  { key: "uniparc", label: "Uniparc" },
  { key: "ccds", label: "ccds" },
  { key: "canonical", label: "Canonical" },
  { key: "ensp", label: "ENSP" },
  { key: "CdsPosition", label: "cdsposition" },
  { key: "cDNAPosition", label: "cdnaposition" },
];

const getCanonical = (canonical) => {
  if (canonical) {
    return "True";
  }
  return "False";
};

const getTdData = (row, key) => {
  /* eslint-disable camelcase */
  const {
    t_ref_count,
    t_alt_count,
    n_ref_count,
    n_alt_count,
    canonical,
    pub_med_references,
    hotspot,
  } = row;

  switch (key) {
    case "hotspot":
      return hotspot ? hotspot.toString() : "-";
    case "pub_med_references":
      return <PublicationLinks ids={pub_med_references} limit={5} />;
    case "canonical":
      return getCanonical(canonical);
    case "tumor_frequency":
      return t_ref_count && t_alt_count
        ? getTumourFreq(t_alt_count, t_ref_count)
        : "-";
    case "normal_frequency":
      return n_ref_count && n_alt_count
        ? getTumourFreq(n_alt_count, n_ref_count)
        : "-";
    default:
      return row[key] !== undefined && row[key] ? formatNumber(row[key]) : "-";
  }
  /* eslint-enable camelcase */
};

const getRowData = (headerOrder, rowData) => {
  const tableKeys = headerOrder.map((r) => r.key);

  return tableKeys.map((c) => ({
    id: uuidv4(),
    content: getTdData(rowData, c),
  }));
};

export const getTableToRender = (cBioportalData) => {
  const c = cBioportalData;
  const firstRowHeader = firstRowHeaderOrder.map((f) => ({
    id: uuidv4(),
    content: f.label,
    styledAs: "header",
  }));
  const upperTableData = getRowData(firstRowHeaderOrder, c);
  const extraHeader = [
    {
      id: uuidv4(),
      content: "Tumor",
      styledAs: "header",
      colSpan: 4,
    },
    {
      id: uuidv4(),
      content: "Normal",
      styledAs: "header",
      colSpan: 4,
    },
    { id: uuidv4(), content: "", styledAs: "header" },
  ];
  const secondRowHeader = secondRowHeaderOrder.map((s) => ({
    id: uuidv4(),
    content: s.label,
    styledAs: "header",
  }));
  const bottomTableData = getRowData(secondRowHeaderOrder, c);
  const backgroundColor = approxSnow;
  const borderColor = titaniumWhite;
  const borderStyle = `1px solid ${borderColor}`;

  return [
    {
      id: uuidv4(),
      columns: extraHeader,
      rowStyles: {
        textAlign: "center",
        borderRight: borderStyle,
        borderLeft: borderStyle,
        backgroundColor,
      },
    },
    {
      id: uuidv4(),
      columns: firstRowHeader,
      rowStyles: {
        borderTop: borderStyle,
        borderRight: borderStyle,
        borderLeft: borderStyle,
        backgroundColor,
      },
    },
    {
      id: uuidv4(),
      columns: upperTableData,
      rowStyles: {
        borderRight: borderStyle,
        borderLeft: borderStyle,
      },
    },
    {
      id: uuidv4(),
      columns: secondRowHeader,
      rowStyles: {
        borderRight: borderStyle,
        borderLeft: borderStyle,
        backgroundColor,
      },
    },
    {
      id: uuidv4(),
      columns: bottomTableData,
      rowStyles: {
        borderRight: borderStyle,
        borderLeft: borderStyle,
        borderBottom: borderStyle,
      },
    },
  ];
};
